import { ArrowDropDownOutlined } from "@mui/icons-material";
import { Button, Divider, Menu, MenuItem } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

function QuickSelect({ selectedCropType, currentYear, setDateRange }) {
  return (
    <PopupState variant="popover" popupId="date-presets-menu">
      {(popupState) => (
        <>
          <Button variant="outlined" fullWidth {...bindTrigger(popupState)}>
            Quick Select <ArrowDropDownOutlined />
          </Button>
          <Menu {...bindMenu(popupState)}>
            <MenuItem
              onClick={() => {
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                setDateRange({ start: thirtyDaysAgo, end: new Date() });
                popupState.close();
              }}
            >
              Last 30 Days
            </MenuItem>
            <MenuItem
              onClick={() => {
                const sixtyDaysAgo = new Date();
                sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);
                setDateRange({ start: sixtyDaysAgo, end: new Date() });
                popupState.close();
              }}
            >
              Last 60 Days
            </MenuItem>
            <MenuItem
              onClick={() => {
                const ninetyDaysAgo = new Date();
                ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
                setDateRange({ start: ninetyDaysAgo, end: new Date() });
                popupState.close();
              }}
            >
              Last 90 Days
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={() => {
                const getGrowingSeasonDates = (cropType, year) => {
                  switch (cropType?.toLowerCase()) {
                    case "wheat":
                      return {
                        start: new Date(year, 8, 15), // September 15th (fall planting)
                        end: new Date(year + 1, 6, 31), // July 31st (next year harvest)
                      };
                    case "cotton":
                      return {
                        start: new Date(year, 3, 15), // April 15th
                        end: new Date(year, 9, 31), // October 31st
                      };
                    case "rice":
                      return {
                        start: new Date(year, 3, 1), // April 1st
                        end: new Date(year, 9, 30), // October 30th
                      };
                    case "corn":
                    case "soybeans":
                    case "sorghum":
                    default:
                      return {
                        start: new Date(year, 3, 1), // April 1st
                        end: new Date(year, 10, 30), // November 30th
                      };
                  }
                };

                const seasonDates = getGrowingSeasonDates(selectedCropType, currentYear);
                setDateRange(seasonDates);
                popupState.close();
              }}
            >
              Growing Season
            </MenuItem>
            <MenuItem
              onClick={() => {
                const startOfSelectedYear = new Date(currentYear, 0, 1);
                const endOfSelectedYear = new Date(currentYear, 11, 31);
                setDateRange({ start: startOfSelectedYear, end: endOfSelectedYear });
                popupState.close();
              }}
            >
              Full Year
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  );
}

export default QuickSelect;
